import React, { Fragment, useState, useEffect } from "react";
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import ReactApexChart from "react-apexcharts";
import axios from "axios";
import API_BASE_URL from '../../../Config/api';

const CollectionChart = ({ collection, skus }) => {
    const chartOptions = {
        chart: {
            type: 'bar',
            height: 350,
            toolbar: {
                show: false
            }
        },
        plotOptions: {
            bar: {
                horizontal: true,
                borderRadius: 4,
                dataLabels: {
                    position: 'top',
                }
            }
        },
        dataLabels: {
            enabled: true,
            offsetX: 30,
            style: {
                fontSize: '12px',
                colors: ['#304758']
            }
        },
        xaxis: {
            categories: skus.map(item => item.sku),
            title: {
                text: 'Quantity Ordered'
            }
        },
        yaxis: {
            title: {
                text: 'SKU'
            }
        },
        colors: ['#008FFB'],
        grid: {
            borderColor: '#f1f1f1',
        }
    };

    const chartSeries = [{
        name: 'Quantity',
        data: skus.map(item => item.quantity)
    }];

    return (
        <Col xl={6} lg={12} md={12} sm={12} className="mb-4">
            <Card>
                <CardHeader className="pb-0">
                    <h5>{collection}</h5>
                    <span className="text-muted">Top 10 SKUs by Order Quantity</span>
                </CardHeader>
                <CardBody>
                    <ReactApexChart
                        options={chartOptions}
                        series={chartSeries}
                        type="bar"
                        height={350}
                    />
                </CardBody>
            </Card>
        </Col>
    );
};

const CollectionCharts = () => {
    const [collectionData, setCollectionData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchCollectionData();
    }, []);

    const fetchCollectionData = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/dashboard/top-skus-by-collection`);
            setCollectionData(response.data);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching collection data:', error);
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <Row>
                <Col sm="12">
                    <Card>
                        <CardBody>
                            <div className="text-center">Loading charts...</div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        );
    }

    if (collectionData.length === 0) {
        return (
            <Row>
                <Col sm="12">
                    <Card>
                        <CardBody>
                            <div className="text-center">No data available</div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        );
    }

    return (
        <Fragment>
            <Row>
                {collectionData.map((item, index) => (
                    <CollectionChart
                        key={index}
                        collection={item.collection}
                        skus={item.skus}
                    />
                ))}
            </Row>
        </Fragment>
    );
};

export default CollectionCharts;
